import React from "react";
import { TabPane } from "reactstrap";
import { TechnicalDesignInputModes } from "stores/product/ui/projectUIStore";
import styles from "../ProductConfigurationResultMainView.module.scss";
import cx from "classnames";
import { ResultingListProvider } from "./providers/ResultingListProvider";
import { ResultingList } from "./components/ResultingList";

export const ResultingListTab = () => {
  return (
    <TabPane tabId={TechnicalDesignInputModes.RESULT_LIST}>
      <div className={cx(styles.productSuggestion, "h-100 w-100")}>
        <ResultingListProvider>
          <ResultingList />
        </ResultingListProvider>
      </div>
    </TabPane>
  );
};
